import { Empty, TreeSelect } from 'antd';
import IDown from '@imgs/icons/down.svg';
import IClear from '@imgs/icons/clear.svg';
import { forwardRef, useImperativeHandle, useRef } from 'react';

function ResetTreeSelect(props: any, ref: any) {
  const treeRef = useRef<any>(null);
  useImperativeHandle(ref, () => ({
    closePanel() {
      treeRef.current?.blur();
    },
  }));
  return (
    <TreeSelect
      ref={treeRef}
      suffixIcon={<IDown className='select-icon-down' />}
      notFoundContent={<Empty />}
      clearIcon={<IClear />}
      {...props}
    >
      {props?.children}
    </TreeSelect>
  );
}

export default forwardRef(ResetTreeSelect);
